<template>
    <v-container>
        <div class="title-page">
            {{ title }}
        </div>
        <loading-spinner v-if="loading" noMarginTop height="100px" />
        <div v-else-if="items.length === 0" class="caption text-center mt-6">
            {{ noItems }}
        </div>
        <v-carousel v-model="currentSlide" hide-delimiters height="100%">
            <v-carousel-item v-for="(item, index) in items" :key="index">
                <v-container class="fill-height d-flex align-center justify-center px-4 pb-6 p-relative">
                    <div class="number-used">{{ index + 1 }}</div>
                    <RoutineCard v-if="type === 'routines'" :routine="item" @click="goToRoutine(item)" />
                    <program-card v-if="type === 'programs'" :program="item" @click="goToProgram(item)" />
                    <block-card v-if="type === 'blocks'" :block="item" />
                    <prescription-card v-if="type === 'prescriptions'" :prescription="item" />
                </v-container>
            </v-carousel-item>
        </v-carousel>
    </v-container>
</template>

<script>

import { db } from '@/utils/Firebase'
import RoutineCard from '../common/routines/RoutineCard.vue';
import ProgramCard from '../common/routines/ProgramCard.vue';
import LoadingSpinner from '../common/LoadingSpinner.vue';
import BlockCard from '../common/routines/BlockCard.vue';
import PrescriptionCard from '../common/routines/PrescriptionCard.vue';

export default {
    name: "MostUsedCarousel",
    components: { RoutineCard, ProgramCard, LoadingSpinner, BlockCard, PrescriptionCard },
    props: {
        type: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            currentSlide: 0,
            items: [],
            loading: false,
        };
    },
    computed: {
        coachId() {
            return this.currentUser.uid || null
        },
        title(vm = this) {
            return vm.$t(`common.most_${vm.type}_used`)
        },
        noItems(vm = this) {
            return vm.$t(`common.no_most_${vm.type}_used`)
        },
    },
    mounted() {
        if (this.type) this.loadItems()
    },
    methods: {
        async loadItems() {
            const vm = this;
            vm.loading = true
            let ref = await db.collection(vm.type)
                .where("coachId", '==', vm.coachId)
                .orderBy("used", "desc")
                .limit(5)
                .get();

            vm.items = ref.docs.map(doc => ({ id: doc.id, objectID: doc.id, ...doc.data() }))
            vm.loading = false
        },
        goToRoutine(routine) {
            const vm = this;
            vm.$router.push({name: 'coach.routines.detail', params: {uid: routine.id}})
        },
        goToProgram(program) {
            const vm = this;
            vm.$router.push({name: 'coach.routines.program.detail', params: {uid: program.id}})
        },
    },
    watch: {
        type(val) {
            if (val) this.loadItems()
        }
    },
};
</script>

<style scoped>
.number-used {
    position: absolute;
    top: 4px;
    right: 4px;
    font-weight: bold;
    background: var(--v-backGroundPrimary-base);
    padding: 4px;
    color: #FFFFFF;
    border-radius: 4px;
}

.title-page {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 12px;
}
</style>